// ฟังก์ชันสำหรับ Decode JWT เพื่อดู Payload (โดยไม่ต้องลง Library เพิ่ม)
export function parseJwt(token) {
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    } catch (e) {
        return null;
    }
}

// ฟังก์ชันเช็คว่า Token หมดอายุหรือยัง
export function isTokenExpired(token) {
    const decoded = parseJwt(token);
    if (!decoded || !decoded.exp) {
        return true; // decoded ไม่ได้ ถือว่าหมดอายุไปเลย
    }

    const currentTime = Date.now() / 1000;
    
    return decoded.exp < currentTime;
}